module.exports = __webpack_public_path__ + "c6948a4d4558978b22841cddaae19266.pdf";